import { Link } from "react-router-dom";
import type { PostSummary } from "../lib/articles";
import { formatDate } from "../lib/format";

export function ArticleCard({ article, index }: { article: PostSummary; index: number }) {
  return (
    <article className="unsub-guide-row">
      <Link to={`/articles/${article.slug}`}>
        <span className="unsub-guide-index">{String(index + 1).padStart(2, "0")}</span>
        <span className="unsub-guide-copy">
          <span className="unsub-guide-meta">
            <time dateTime={article.publishedAt}>{formatDate(article.publishedAt)}</time>
            {article.readTime ? <span>{article.readTime} min read</span> : null}
          </span>
          <strong>{article.title}</strong>
          {article.excerpt ? <span className="unsub-guide-excerpt">{article.excerpt}</span> : null}
        </span>
        <span className="unsub-guide-arrow" aria-hidden="true">→</span>
      </Link>
    </article>
  );
}
